export * from './block.shortcodes.blot';


// WEBPACK FOOTER //
// ./src/app/content/shared/components/inputs/body/quill/blots/shortcode/block/index.ts